import { createFaasProcedureConfig } from '@americanexpress/iguazu-procedures/utils/createFaasProcedureConfig';
import withOriginServerHeader from './withOriginServerHeaders';
import withExpandedError from './withExpandedErrors';

// https://explorer.aexp.com/functions/ReadCustomerProducts.v2
const baseConfig = createFaasProcedureConfig(
  'ReadCustomerProducts.v2',
  ({ headers, ...args }) => ({
    ...headers ? { headers } : {},
    body: JSON.stringify(args),
  })
);

export default withExpandedError(withOriginServerHeader(baseConfig));
